import { api } from './api'

/**
 * 담당자코드 조회
 * @param {object} data - { parent_code: 그룹코드 }
 * @returns response data
 */

const getMangerVerf = data =>
  new Promise((resolve, reject) => {
    data = { manager_code: data.manager_code }

    api
      .post('/api/v1/cmmn/mangerVerf', data)
      .then(response => {
        const resDate = response.data
        if (resDate.result_code === '00000') {
          data = { ...response.code, ...data, ...resDate.data, result_code: resDate.result_code }
          resolve(data)
        } else {
          data = { ...data, ...resDate.data, result_code: resDate.result_code }
          // reject({ code: resDate.result_code, message: resDate.result_msg })
          resolve(data)
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })

const spgeCfMangerVerify = data =>
  new Promise((resolve, reject) => {
    data = { manager_code: data.manager_code }

    api
      .post('/api/v1/cmmn/spge-cf/mangerVerf', data)
      .then(response => {
        const resDate = response.data
        if (resDate.result_code === '00000') {
          data = { ...response.code, ...data, ...resDate.data, result_code: resDate.result_code }
          resolve(data)
        } else {
          data = { ...data, ...resDate.data, result_code: resDate.result_code }
          // reject({ code: resDate.result_code, message: resDate.result_msg })
          resolve(data)
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })

/**
 * 코드 정보 조회
 * @param {object} data - { parent_code: 그룹코드 }
 * @returns response data
 */
const getCodeInfo = data =>
  new Promise((resolve, reject) => {
    data = { parent_code: data.parent_code }

    api
      .post('/api/v1/cmmn/getCodeInfo', null, { params: data })
      .then(response => {
        const resData = response.data

        if (resData.result_code === '00000') {
          data = { ...data, ...resData.data }
          resolve(data)
        } else {
          reject({ code: resData.result_code, message: resData.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })

/**
 * 코드 목록 조회
 * @param {object} data - { parent_code: 그룹코드 }
 * @returns response data
 */
const getCodeList = data =>
  new Promise((resolve, reject) => {
    data = { parent_code: data.parent_code }

    api
      .post('/api/v1/cmmn/getCodeList', null, { params: data })
      .then(response => {
        const resData = response.data

        if (resData.result_code === '00000') {
          data = { ...data, data: resData.data }
          resolve(data)
        } else {
          reject({ code: resData.result_code, message: resData.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })

const getShopAccount = data =>
  new Promise((resolve, reject) => {
    api
      .get(`/api/v1/ceo/account/info?shop_idx=${data}`)
      .then(response => {
        const resData = response.data

        if (resData.code === '200') {
          data = { ...data, ...resData.data }
          resolve(data)
        } else {
          reject({ code: resData.result_code, message: resData.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })

const spgeFMangerVerify = data =>
  new Promise((resolve, reject) => {
    data = { manager_code: data.manager_code }

    api
      .post('/api/v1/cmmn/spge-f/mangerVerf', data)
      .then(response => {
        const resDate = response.data
        if (resDate.result_code === '00000') {
          data = { ...response.code, ...data, ...resDate.data, result_code: resDate.result_code }
          resolve(data)
        } else {
          data = { ...data, ...resDate.data, result_code: resDate.result_code }
          // reject({ code: resDate.result_code, message: resDate.result_msg })
          resolve(data)
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })

const apiGetShopByBizNo = async data => {
  return new Promise((resolve, reject) => {
    api
      .get('/api/v1/cmmn/infoByBizNo/' + data.biz_no)
      .then(response => {
        console.log('response', response)
        const resDate = response.data
        if (resDate.result_code === '00000') {
          resolve({ ...data, ...resDate.data })
        } else {
          reject({ code: resDate.result_code, message: resDate.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })
}

const commonConfig = { apiGetShopByBizNo, getCodeInfo, getCodeList, getMangerVerf, spgeCfMangerVerify, getShopAccount, spgeFMangerVerify }

export { commonConfig }
